<template>
<div class="poster">
    <div class="hnw-area-center">
        <div class="pos-main">
            <!-- 将tabs和搜索框并排放置 -->
            <div class="header-container" v-if="pageMode==1">
                <el-tabs v-model="posMode" @tab-click="handleClick" class="tabs-container">
                    <el-tab-pane label="海报库" name="allPos">
                    </el-tab-pane>
                    <el-tab-pane label="我的海报" name="myPos">
                    </el-tab-pane>
                    <el-tab-pane label="待审核" name="prePos">
                    </el-tab-pane>
                </el-tabs>
                
                <!-- 搜索框 -->
                <div class="search-container" >
                    <el-input 
                        v-if="posMode=='allPos' && selectedGroupIndex === -1"
                        v-model="searchKeyword" 
                        placeholder="请输入海报标题"
                        prefix-icon="el-icon-search"
                        clearable
                        size="mini"
                        @input="searchPosters"
                        style="width: 250px;">
                    </el-input>
                    <div class="manage-container" v-if=" pageMode==1 && posMode !== 'allPos'">
                        <div 
                            v-if="!isManaging" 
                            @click="startManage" 
                            style="width: 80px; height: 28px; background-color: #063376; margin-left: 10px; display: flex; align-items: center; justify-content: center; color: white; border-radius: 4px; cursor: pointer; font-size: 12px;">
                            海报管理
                        </div>
                        <div v-else class="manage-actions">
                            <el-button size="mini" @click="cancelManage" style="margin-right: 5px;">
                                取消
                            </el-button>
                            <!-- <el-button 
                                v-if="posMode=='allPos'" 
                                type="primary" 
                                size="mini" 
                                @click="batchDownload"
                                :disabled="selectedPosters.length === 0">
                                批量下载 ({{ selectedPosters.length }})
                            </el-button> -->
                            <el-button 
                                v-if="posMode=='myPos' || posMode=='prePos'" 
                                type="danger" 
                                size="mini" 
                                @click="batchDelete"
                                :disabled="selectedPosters.length === 0">
                                批量删除 ({{ selectedPosters.length }})
                            </el-button>
                        </div>
                    </div>
                </div>
                
                <!-- 管理按钮 -->
            </div>
            
            <!-- 组选择器：将所有组的标题图片放到一行 -->

            <div class="group-selector" v-if="posList.length > 0 && pageMode==1" ref="groupSelector" :class="{'sticky': isGroupSelectorSticky}">
                <div 
                    v-for="(group, index) in posList" 
                    :key="index" 
                    class="group-item"
                    :brand="group.title"
                    :class="{ active: selectedGroupIndex === index }"
                    @click="selectGroup(index)"
                    v-show="!group.hide && group.posters.length > 0"
                >
                    <img class="group-img" :src="group.image" alt="" />
                    
                </div>
            </div>
            
            <!-- 显示选中组的内容或所有组的内容 -->
            <template v-if="selectedGroupIndex >= 0 && pageMode==1">
                <div class="mode-item" :class="{'statrt-mode': posMode=='allPos'}">
                    <div class="mode-head">
                        <div class="head-title">
                        <!-- 饿 -->
                            <!-- <img class="head-img" :src="posList[selectedGroupIndex].image" alt="" srcset="">
                            <span class="mode-title">{{ posList[selectedGroupIndex].title || '默认组' }}</span> -->
                        </div>
                        <div class="head-right">
                            <el-button type="primary" size="mini" @click.stop="showAllGroups">返回全部</el-button>
                        </div>
                    </div>
                    <div class="mode-imgs">
                        <div class="list">
                            <el-row :gutter="10">
                                <!-- 显示选中组的所有海报 -->
                                <el-col v-for="(pos,index) in posList[selectedGroupIndex].allPosters" :key="index" :span="3">
                                    <div class="card-box">
                                        <div class="item-card">
                                            <div class="list-poster-body"> 
                                                <img v-if="isExpired(pos.time)" class="poster-sx-icon" src="../../assets/common/shangxin.png" alt="">
                                                <img v-if="pos.status==1 " @click.stop="copyPoster(pos,1)" :src="pos.image" alt="" style="{width:100%}">
                                                <el-image
                                                    v-else
                                                    style="{width:100%}"
                                                    :src="pos.image"
                                                    :preview-src-list="[pos.image]"
                                                ></el-image>
                                                <div v-if="pos.txt_name" class="pos-texts" :style="{'background-color':pos.tem_color}">
                                                  <div class="companyName">{{pos.txt_name}}</div>
                                                  <div class="companyName time-content" v-if="pos.content">放假日期:{{pos.content}}</div>
                                                  <div class="phone">电话: {{pos.txt_phone}}</div>
                                                  <div class="address">地址: {{pos.txt_address}}</div>
                                                </div>
                                            </div>

                                            <div class="card-bottom">
                                                <div class="bot-left" :title="pos.title" >
                                                    {{pos.title}}
                                                </div>
                                                <div class="bot-btns">
                                                    <!-- 管理模式下的选择框 -->
                                                    <el-checkbox 
                                                        v-if="isManaging" 
                                                        class="poster-checkbox-bottom"
                                                        :value="selectedPosters.includes(pos.id)"
                                                        @change="() => togglePosterSelection(pos.id)">
                                                    </el-checkbox>
                                                    
                                                    <div class="btn cre" v-if="posMode=='allPos' && !isManaging" @click="createPoster(posList[selectedGroupIndex],pos)">
                                                        生成海报
                                                    </div>
                                                    <div class="btn cop" v-if="posMode=='myPos' && !isManaging" @click.stop="copyPoster(pos)">
                                                        <img class="btn-img copy-btn" src="../../assets/common/copy.png" alt=""> 复制图片
                                                    </div>
                                                    <div class="btn exam" v-if="posMode=='prePos' && !isManaging" @click.stop="$warMsg('正在审核')">
                                                        审核中
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </div>
            </template>
            
            <!-- 显示所有组的内容（默认情况或点击查看更多时） -->
            <template v-for="(group,index) in posList" v-else>
                <div class="mode-item" :key="index" :class="{'statrt-mode': posMode=='allPos'}" v-show="!group.hide&&group.posters.length>0">
                    <div class="mode-head">
                        <div class="head-title">
                            <img class="head-img" :src="group.image" alt="" srcset="">
                        </div>
                        <div class="head-right">
                            <el-button type="primary" size="mini" v-if="pageMode==2" @click.stop="reMore(group,1)">返回列表</el-button>
                            <div @click="reMore(group,2)" v-else>
                                <template>
                                    查看更多
                                <i class="el-icon-arrow-right"></i>
                                </template>
                            </div>
                        </div>
                    </div>
                    <!--  -->
                    <div class="mode-imgs">
                        <div class="list">
                            <el-row :gutter="10">
                                <!-- 显示每个组的海报（最多8个） -->
                                <el-col v-for="(pos,index) in group.posters" :key="index" :span="3">
                                    <div class="card-box">
                                        <div class="item-card">
                                            <div class="list-poster-body">
                                                <img class="poster-sx-icon" v-if="isExpired(pos.time)" src="../../assets/common/shangxin.png" alt="">
                                                <img v-if="pos.status==1" @click.stop="copyPoster(pos,1)" :src="pos.image" alt="" style="{width:100%}">
                                                <el-image
                                                    v-else
                                                    style="{width:100%}"
                                                    :src="pos.image"
                                                    :preview-src-list="[pos.image]"
                                                ></el-image>
                                                <div v-if="pos.txt_name" class="pos-texts" :style="{'background-color':pos.tem_color}">
                                                  <div class="companyName">{{pos.txt_name}}</div>
                                                  <div class="companyName time-content" v-if="pos.content">放假日期:{{pos.content}}</div>
                                                  <div class="phone">电话: {{pos.txt_phone}}</div>
                                                  <div class="address">地址: {{pos.txt_address}}</div>
                                                </div>
                                            </div>
                                            <div class="card-bottom">
                                                <div class="bot-left" :title="pos.title" >
                                                    {{pos.title}}
                                                </div>
                                                <div class="bot-btns">
                                                    <!-- 管理模式下的选择框 -->
                                                    <el-checkbox 
                                                        v-if="isManaging" 
                                                        class="poster-checkbox-bottom"
                                                        :value="selectedPosters.includes(pos.id)"
                                                        @change="() => togglePosterSelection(pos.id)">
                                                    </el-checkbox>
                                                    
                                                    <div class="btn cre" v-if="posMode=='allPos' && !isManaging" @click="createPoster(group,pos)">
                                                        生成海报
                                                        <!-- <img class="btn-img" src="../../assets/index/hb-r.png" alt=""> -->
                                                    </div>
                                                    <div class="btn cop" v-if="posMode=='myPos' && !isManaging" @click.stop="copyPoster(pos)">
                                                        <img class="btn-img copy-btn" src="../../assets/common/copy.png" alt=""> 复制图片
                                                    </div>
                                                    <div class="btn exam" v-if="posMode=='prePos' && !isManaging" @click.stop="$warMsg('正在审核')">
                                                        审核中
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
    
    <sharePoster ref="sharePoster" :goodsInfo="posInfo" :posBackColor="posBackColor" :posBackbodyImg="posBackbodyImg"></sharePoster>
    
    <!-- 添加加载提示 -->
    <el-dialog title="" :visible.sync="loadingVisible" :show-close="false" :modal="true" width="30%" top="40vh" custom-class="loading-dialog">
      <div style="text-align: center; padding: 20px;">
        <i class="el-icon-loading" style="font-size: 30px; color: #409EFF;"></i>
        <p style="margin-top: 15px; font-size: 16px;">图片生成中，请稍候...</p>
      </div>
    </el-dialog>
</div>
</template>

<script>
export default {
  data() {
    return {
      url:"",
      posList:[],
      posMode:"allPos",
      posInfo:{},
      limit:10,
      page:1,
      pageMode:1,
      searchKeyword: '',
      selectedGroupIndex: -1, // 默认不选中任何组，-1表示显示所有组
      // 添加吸顶效果相关数据
      isGroupSelectorSticky: false,
      groupSelectorOffsetTop: 0,
      // 添加管理状态相关数据
      isManaging: false,
      selectedPosters: [], // 存储选中的海报ID
      // 添加加载提示相关数据
      loadingVisible: false,
      posBackColor:"",
      posBackbodyImg:""
    }
  },
  methods: {
    // 添加处理滚动事件的方法
    handleScroll() {
      // 获取滚动位置
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      
      // 当滚动距离大于等于导航栏初始位置时，启用吸附效果
      // 当滚动距离小于导航栏初始位置时，取消吸附效果
      // 添加元素存在性检查，确保在元素不存在时能正确取消吸顶状态
      if (this.$refs.groupSelector) {
        this.isGroupSelectorSticky = scrollTop >= this.groupSelectorOffsetTop;
      } else {
        // 如果元素不存在，确保取消吸顶状态
        this.isGroupSelectorSticky = false;
      }
    },
    // 添加窗口大小调整处理方法
    handleResize() {
      // 重新计算导航栏位置
      this.$nextTick(() => {
        if (this.$refs.groupSelector) {
          // 重新获取元素在页面中的绝对位置
          const rect = this.$refs.groupSelector.getBoundingClientRect();
          // 确保获取到正确的偏移量
          if (rect.top >= 0) {
            this.groupSelectorOffsetTop = rect.top + window.pageYOffset;
          } else {
            // 如果元素在视口上方，使用其原始位置
            this.groupSelectorOffsetTop = window.pageYOffset + rect.top;
          }
        } else {
          // 如果元素不存在，重置偏移量和吸顶状态
          this.groupSelectorOffsetTop = 0;
          this.isGroupSelectorSticky = false;
        }
      });
    },
    async handleClick(tab, event) {
      this.getPosterGroupList()
      // 重置选中组
      this.selectedGroupIndex = -1
      // 重置管理状态和选中的海报
      this.isManaging = false;
      this.selectedPosters = [];
    },
    // 选择组
    selectGroup(index) {
      this.selectedGroupIndex = index
    },
    isExpired(timestamp) {
        // 1. 定义 15 天的毫秒数
        // 15天 * 24小时 * 60分钟 * 60秒 * 1000毫秒
        const fifteenDaysInMs = 15 * 24 * 60 * 60 * 1000;

        // 2. 获取当前时间戳 (毫秒)
        const now = Date.now();

        // 3. 处理传入的时间戳
        // 如果传入的是 10 位数字（秒），需要 * 1000
        // 如果传入的是 13 位数字（毫秒），则保持不变
        // 这里做一个简单的判断逻辑：如果数字小于 10^12，通常认为是秒级时间戳
        let targetTime = timestamp;
        if (timestamp < 1000000000000) {
            targetTime = timestamp * 1000;
        }

        // 4. 计算时间差
        const diff = now - targetTime;

        // 5. 判断是否超过 15 天
        // 如果 diff > 15天的毫秒数，说明已经过去超过 15 天
        return diff < fifteenDaysInMs;
    },
    // 显示所有组
    showAllGroups() {
      this.selectedGroupIndex = -1
      // 恢复每个组只显示最多8个海报
      this.posList.forEach(group => {
        if (group.allPosters) {
          group.posters = group.allPosters.slice(0, 8)
        }
      })
    },
    reMore(group,type){
      this.pageMode = type
      if(type==2){
        group.posters = [...group.allPosters]
        this.posList.forEach(item=>item.hide=true)
        group.hide = false
      }else{
        this.posList.forEach(item=>item.hide=false)
        group.posters = group.allPosters.slice(0,16)
      }
      // 重置选中组
      this.selectedGroupIndex = -1
    },
        
    async searchPosters() {
      // 过滤标题包含搜索关键词的海报
      let res = await this.$api.getSystemPoster({
        limit:this.limit,
        page:this.page,
        title:this.searchKeyword
      }) 

      res.db.forEach(group => {
        group.allPosters = [...group.posters]
        group.posters = group.posters.slice(0,16)
      }); 
      this.posList = res.db
      // 重置选中组
      this.selectedGroupIndex = -1
    },
    async getPosterGroupList(){
      let res = ""
      if(this.posMode=='allPos'){
        res = await this.$api.getSystemPoster({
          limit:this.limit,
          page:this.page
        }) 

        res.db.forEach(group => {
          group.allPosters = [...group.posters]
          group.posters = group.posters.slice(0,16)
        }); 
      }else{
        let status = 1
        switch (this.posMode) {
          case 'prePos':
            status = 2
            break;
          case 'myPos':
            status = 1
            break;
          default:
            break;
        }
        res = await this.$api.getUserPoster({
          limit:this.limit,
          page:this.page,
          status
        })

        res.db.forEach(group => {
          group.image = group.group_image
          group.title = group.group_title
          group.allPosters = [...group.posters]
          group.posters = group.posters.slice(0,16)
          group.posters.forEach(pos=>{
            pos.image = pos.tem_image
            pos.title = pos.tem_title
            // 更新已读 
            if(this.posMode=="myPos"){
              this.$api.updateMessage({
                type:"poster", // demand表示需求，poster表示海报
                remarks:2, // 1表示商家已读，2表示用户已读
                id:pos.id // 消息id
              })
            }
            
          })
        }); 
      }

      // 添加品牌过滤逻辑
      const exBrands = this.$store.state.exBrands ? this.$store.state.exBrands.split(',') : [];
      if (exBrands.length > 0) {
        res.db = res.db.filter(group => {
          // 特别处理"卢卡斯"品牌，需要同时检查"卢卡斯"和"Lucas"
          if (group.title === '卢卡斯' || group.title === 'Lucas') {
            return !exBrands.includes('卢卡斯') && !exBrands.includes('Lucas');
          }
          // 其他品牌直接检查是否在过滤列表中
          return !exBrands.includes(group.title);
        });
      }

      this.posList = res.db
      this.total = res.total
      
      // 数据加载完成后重新计算导航栏位置
      this.$nextTick(() => {
        this.recalculateNavPosition();
      });
      
      // 默认选中第一个组（如果有组的话）
      if (this.posList.length > 0 && this.pageMode == 1) {
        // 不再默认选中第一个组，让用户自己选择
        // this.selectedGroupIndex = 0
      }
    },
    // 重新计算导航栏位置的方法
    recalculateNavPosition() {
      if (this.$refs.groupSelector) {
        // 重新获取元素在页面中的绝对位置
        const rect = this.$refs.groupSelector.getBoundingClientRect();
        // 确保获取到正确的偏移量
        if (rect.top >= 0) {
          this.groupSelectorOffsetTop = rect.top + window.pageYOffset;
        } else {
          // 如果元素在视口上方，使用其原始位置
          this.groupSelectorOffsetTop = window.pageYOffset + rect.top;
        }
      } else {
        // 如果元素不存在，重置偏移量和吸顶状态
        this.groupSelectorOffsetTop = 0;
        this.isGroupSelectorSticky = false;
      }
    },
    createPoster(group,pos){
      this.posInfo = pos
      this.posInfo.group_title = group.title
      
      this.posInfo.groupId = group.id
      this.posInfo.temId = pos.id
      this.$refs.sharePoster.posNum = 1
      this.posInfo.goodsPosImg = [{
        image:pos.image,
        g_production:pos.g_production
      }]
      this.$nextTick(()=>{
        this.$refs.sharePoster.sharePoster()
      })
    },
    delPos(id){
      this.$affMsg("确认删除?",async ()=>{
        await this.$api.delUserPoster(id)
        this.getPosterGroupList()
        this.$suMsg("删除成功")
      })
    },
    copyPoster(pos,type){
      // 显示加载提示
      // this.loadingVisible = true;
      
      this.$refs.sharePoster.shareVis = true
      this.$refs.sharePoster.posNum = 2
      let replaStrat = window.location.hostname.startsWith('www.')?'https://www.':"https://";
      this.$refs.sharePoster.posterInfo.bodyImg = pos.tem_image.replace('https://image.oos.huanuowei.cn', replaStrat+`huanuowei.cn/agent-image`)
      this.$refs.sharePoster.posterInfo.backColor = pos.tem_color
      this.posBackColor = pos.tem_color
      this.posBackbodyImg = pos.tem_image.replace('https://image.oos.huanuowei.cn', replaStrat+`huanuowei.cn/agent-image`)
      this.$refs.sharePoster.posterInfo.goods_name = pos.tem_title
      this.$refs.sharePoster.posterInfo.name = pos.txt_name
      this.$refs.sharePoster.posterInfo.phone = pos.txt_phone
      this.$refs.sharePoster.posterInfo.address = pos.txt_address
      this.$refs.sharePoster.posterInfo.content = pos.content
      console.log("图片",this.posBackbodyImg);
      console.log("颜色",this.posBackColor);
      if(type==1){
        // 关闭加载提示
        // this.loadingVisible = false;
      }else{
        setTimeout(()=>{
          this.$nextTick(()=>{
            this.$refs.sharePoster.exportToPNG()
          })
        },0)
        
      }
    },
    
    // 开始管理状态
    startManage() {
      this.isManaging = true;
      this.selectedPosters = [];
    },
    
    // 取消管理状态
    cancelManage() {
      this.isManaging = false;
      this.selectedPosters = [];
    },
    
    // 切换海报选中状态
    togglePosterSelection(posId) {
      const index = this.selectedPosters.indexOf(posId);
      if (index > -1) {
        // 如果已选中，则取消选中
        this.selectedPosters.splice(index, 1);
      } else {
        // 如果未选中，则选中
        this.selectedPosters.push(posId);
      }
    },
    
    // 全选当前组的海报
    selectAllPosters() {
      let posters = [];
      if (this.selectedGroupIndex >= 0) {
        // 选中组模式
        posters = this.posList[this.selectedGroupIndex].allPosters.map(pos => pos.id);
      } else {
        // 所有组模式
        this.posList.forEach(group => {
          group.posters.forEach(pos => {
            posters.push(pos.id);
          });
        });
      }
      this.selectedPosters = posters;
    },
    
    // 批量下载
    batchDownload() {
      if (this.selectedPosters.length === 0) {
        this.$warMsg("请先选择要下载的海报");
        return;
      }
      
      // 显示加载提示
      this.loadingVisible = true;
      
      // 创建一个计数器来跟踪下载进度
      let downloadedCount = 0;
      const totalToDownload = this.selectedPosters.length;
      
      // 遍历所有选中的海报
      this.selectedPosters.forEach((posterId, index) => {
        // 查找海报对象
        let poster = null;
        for (let group of this.posList) {
          if (group.allPosters) {
            poster = group.allPosters.find(p => p.id === posterId);
          } else {
            poster = group.posters.find(p => p.id === posterId);
          }
          
          if (poster) break;
        }
        
        if (poster) {
          // 使用 setTimeout 来避免阻塞 UI
          setTimeout(() => {
            
            let replaStrat = window.location.hostname.startsWith('www.')?'https://www.':"https://";
            const imageUrl =  poster.image.replace('https://image.oos.huanuowei.cn', replaStrat+`huanuowei.cn/agent-image`);

            const filename = `${poster.title || '海报'}.png`;
            
            // 如果是 base64 图片或者同源图片，可以直接下载
            this.downloadImage(imageUrl, filename);
            downloadedCount++;
            
            // 检查是否所有图片都已下载
            if (downloadedCount === totalToDownload) {
              this.loadingVisible = false;
              this.$suMsg(`成功下载 ${totalToDownload} 张海报`);
            }
            
          }, index * 300); // 添加延迟以避免同时发起太多请求
        }
      });
    },
    downloadImage(dataUrl, filename) {
     
      
      const a = document.createElement('a');
      a.href = dataUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    // 从 URL 下载图片的新方法
    downloadImageFromUrl(imageUrl, filename) {
      return new Promise((resolve, reject) => {
        // 创建一个 canvas 元素来处理跨域图片
        const img = new Image();
        img.crossOrigin = 'anonymous'; // 设置跨域
        
        img.onload = () => {
          try {
            // 创建 canvas 并绘制图片
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            
            // 转换为 base64 并下载
            const dataUrl = canvas.toDataURL('image/png');
            this.downloadImage(dataUrl, filename);
            resolve();
          } catch (err) {
            reject(err);
          }
        };
        
        img.onerror = () => {
          // 如果无法直接加载图片，尝试通过代理方式
          reject(new Error('图片加载失败'));
        };
        
        img.src = imageUrl;
      });
    },
    // 批量删除
    batchDelete() {
      if (this.selectedPosters.length === 0) {
        this.$warMsg("请先选择要删除的海报");
        return;
      }
      
      this.$affMsg(`确认删除选中的${this.selectedPosters.length}张海报?`, async () => {
        try {
          // 将选中的ID拼接成字符串
          const ids = this.selectedPosters.join(',');
          await this.$api.delUserPoster(ids);
          this.getPosterGroupList();
          this.selectedPosters = []; // 清空选中状态
          this.$suMsg("删除成功");
        } catch (error) {
          this.$errMsg("删除失败");
          console.error(error);
        }
      });
    }
  },

  async created(){
    // 判断是否是点击海报审核通知过来的
    if (this.$route.query.from === 'posterApproved') {
      // 可以在这里添加特定的处理逻辑
      this.posMode='myPos' 
      console.logallPos
      
    }
    this.getPosterGroupList()
    
  },
  mounted() {
    // 计算导航栏初始位置
    this.$nextTick(() => {
      if (this.$refs.groupSelector) {
        // 获取元素在页面中的绝对位置
        const rect = this.$refs.groupSelector.getBoundingClientRect();
        this.groupSelectorOffsetTop = rect.top + window.pageYOffset;
        // 确保获取到正确的偏移量
       
      } else {
        // 如果元素不存在，重置偏移量和吸顶状态
        this.groupSelectorOffsetTop = 0;
        this.isGroupSelectorSticky = false;
      }
    });
    
    // 添加滚动和窗口大小调整事件监听器
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>

<style lang="scss">
.poster{
    background: #F9F9F9;
    .hnw-area-center{
        background: #fff;
    }
    .el-dialog__header{
        padding: 0;
        padding-top: 5px;
    }
    .pos-main{
        padding: 0 10px;
        min-height: 200px;
        
        /* 新增样式：使tabs和搜索框并排显示 */
        .header-container {
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            flex-wrap: wrap;
            
            .tabs-container {
                flex: 1;
                min-width: 300px;
            }
            
            .search-container {
                position: absolute;
                right: 0px;
                bottom: 6px;
                display: flex;
                
                .el-input__inner {
                    // border: 1px solid #333;
                }
                .manage-container {
                  margin-left: 10px;
                }
                // margin-right: 20px;
                // margin-top: 5px;
                // margin-left: 20px;
                // flex-shrink: 0;
            }
            
            // .manage-container {
            //     position: absolute;
            //     right: 0px;
            //     bottom: 6px;
            // }
        }
        
        .el-tabs__header{
            margin: 0;
        }
        
        /* 组选择器样式 */
        .group-selector {
            display: flex;
            flex-wrap: nowrap;
            overflow-x: auto;
            // padding: 10px 0;
            // margin: 10px 0;
            padding-bottom: 8px;
            margin-top: 10px;
            border-bottom: 1px solid #eee;
            
            // 吸附样式
            &.sticky {
                position: fixed;
                top: 0;
                left: 50%;
                transform: translateX(-50%);
                width: calc(100% - 40px); // 考虑左右padding
                max-width: 1200px; // 限制最大宽度
                box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                padding-bottom: 8px;
                margin-top: 0;
                background: #fff;
                z-index: 100;
                border-bottom: 1px solid #eee;
            }
            
            .group-item {
                flex: 0 0 auto;
                text-align: center;
                margin-right: 15px;
                cursor: pointer;
                padding: 3px 8px;
                margin-right: 10px;
                background-color: #fff;
                
                
                border-radius: 4px;
                transition: all 0.3s;
                
                &:hover {
                    border-color: #063376 ;
                }
                &.active {
                    border-color: #063376 ;
                    background-color: #063376 ;
                }
                .group-img {
                    width: 160px;
                    // height: 50px;
                    object-fit: cover;
                }
                
                .group-title {
                    font-size: 12px;
                    margin-top: 5px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }
        .statrt-mode{
          .item-card{
            height: 232px !important;
            max-height: 232px !important;
          }
        }
        .mode-item{
            .mode-head{
                display: flex;
                align-items: center;
                justify-content: space-between;
                .head-title{
                    display: flex;
                    align-items: center;
                    padding: 13px 0;
                    .head-img{
                        height: 40px;
                        // width: 100px;
                    }
                    .mode-title{
                        margin-left: 10px;
                    }
                }
                .head-right{
                    cursor: pointer;
                    margin-bottom: 5px;
                }
            }
            .mode-imgs{
                // border-bottom: 1px solid #EFEFEF;
                .list{
                    display: flex;
                    flex-wrap: wrap;
                    // background: #F9F9F9;
                    .el-row{
                        width: 100%;
                        .el-col{
                            border-bottom: 2px solid  #EFEFEF;
                            margin-bottom: 10px;
                        }
                    }
                    .card-box{
                        width: 100%;
                        position: relative;
                        
                        // 选择框样式
                        .poster-checkbox {
                            position: absolute;
                            top: 5px;
                            left: 5px;
                            z-index: 10;
                        }
                        
                        box-sizing: border-box;
                        // padding: 0 5px;
                        margin-bottom: 10px;
                        // margin: 5px 0;
                        background: #fff;
                        .item-card{
                           
                            .list-poster-body{
                                position: relative;
                                overflow: hidden;
                                text-align: center;
                                background: #fff;
                                .poster-sx-icon{
                                    width: 30px;
                                    // height: 20px;
                                    position: absolute;
                                    top: 0px;
                                    right: 0px;
                                    z-index: 10;
                                }
                                img{
                                    // pointer-events: none;
                                    width: 100%;
                                }
                                .pos-texts{                               
                                    width: 100%;
                                    padding: 5px;
                                    padding-left: 10px;
                                    // padding-left: 70px;
                                    box-sizing: border-box;
                                    color: #fff;
                                    text-align: left;
                                    >div{
                                        font-size: 12px;
                                        overflow: hidden; //超出的文本隐藏
                                        text-overflow: ellipsis; //溢出用省略号显示
                                        white-space: nowrap; //溢出不换行
                                    }
                                    .companyName{
                                        font-size: 14px;
                                        font-weight: 700;
                                    }
                                    .time-content{
                                        margin-top: 5px;
                                    }
                                    .phone{
                                        margin: 5px 0;
                                    }
                                    // .address{
                                    //   margin-top: 10px;
                                    // }

                                }
                            }

                            .card-bottom{
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                padding: 5px 0;

                                .bot-left{
                                    // max-width: 60px;
                                    flex: 1;
                                    text-overflow: ellipsis;
                                    overflow: hidden;
                                    white-space: nowrap;
                                }
                                .bot-btns{
                                    display: flex;
                                    align-items: center;
                                    
                                    // 选择框样式（放在按钮区域）
                                    .poster-checkbox-bottom {
                                        margin-right: 8px;
                                        transform: scale(1.3);
                                        .el-checkbox__inner{
                                          border: 1px solid #063376;
                                        }
                                    }
                                    
                                    .btn{
                                        cursor: pointer;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        padding: 4px 6px;
                                        font-size: 12px;
                                        border-radius: 13px;
                                        .btn-img{
                                            width: 15px;
                                        }
                                        .copy-btn{
                                            margin-right: 5px;
                                        }
                                    }
                                    .cre{
                                        color: #fff;
                                        // background: #0b53be;
                                        background: #063376;
                                        transform: scale(0.9);
                                    }
                                    .cop{
                                        color: #86bcff;
                                        padding: 0;
                                    }
                                    .exam{
                                        background: #063376;
                                        color: #fff;
                                    }
                                }

                            }
                        }
                    }
                }
            }
        }
    }
}
// 添加加载对话框样式
.loading-dialog {
  .el-dialog__header {
    padding: 0;
  }
  
  .el-dialog__body {
    padding: 0;
  }
}
</style>
